import {NgModule} from '@angular/core';
import {DmConfigPage} from "./page/overview/dm-config/dm-config.page";
import {DmDashboardComponent} from "./component/protected-components/dm-dashboard/dm-dashboard.component";
import {DmUploadComponent} from "./component/protected-components/upload/dm-upload.component";
import {DmDocumentComponent} from "./component/protected-components/dm-document/dm-document.component";
import {
    DmFormRecognizerDataComponent,
    FormRecognizerCanvasDirective
} from "./component/protected-components/dm-form-recognizer-data/dm-form-recognizer-data.component";
import {DmDashboardOverviewPage} from "./page/overview/dm-dashboard-overview/dm-dashboard-overview.page";
import {DmDocumentPage} from "./page/overview/dm-document/dm-document.page";
import {ProgressSpinnerModule} from "primeng/progressspinner";
import {ObjectDocumentComponent} from "./component/protected-components/object-documents/object-documents.component";
import {
    DialogBoxObjectDocumentComponent
} from "./component/protected-components/dialog-box-object-documents/dialog-box-object-documents.component";
import {
    DmDocumentPdfViewerComponent
} from "./component/protected-components/dm-document-pdf-viewer/dm-document-pdf-viewer.component";
import {
    DmDocumentUploadWfProcessStepActivityComponent
} from "./component/protected-components/wf/dm-document-upload-wf-process-step-activity/dm-document-upload-wf-process-step-activity.component";
import {WfModule} from "../wf/wf.module";
import {DmDashboardActionsPage} from "./page/overview/dm-dashboard-actions-page/dm-dashboard-actions.page";
import {
    DmDocumentProcessingComponent
} from "./component/protected-components/dm-document-processing/dm-document-processing.component";
import {ContextMenuModule} from "primeng/contextmenu";
import {TabsModule} from "primeng/tabs";
import {
    DmDocumentUploadComponent
} from './component/protected-components/dm-document-upload/dm-document-upload.component';
import {
    DocumentProcessActionsComponent
} from "./component/protected-components/document-process-actions/document-process-actions.component";
import {DmOverviewPage} from "./page/dm-overview-page/dm-overview.page";
import {DmStatisticsComponent} from "./page/dm-overview-page/components/statisticsComponent/dm-statistics.component";
import {DmKpiComponent} from "./page/dm-overview-page/components/kpiComponent/dm-kpi.component";
import {
    DmDocumentFullComponent
} from "./component/protected-components/dm-document/view/dm-document-full/dm-document-full.component";
import {
    DmDocumentSideComponent
} from "./component/protected-components/dm-document/view/dm-document-side/dm-document-side.component";
import {DmDocumentBaseComponent} from "./component/protected-components/dm-document/view/dm-document-base.component";
import {DM_ENTITY_PROVIDER} from "./dm.entity-provider";
import {CoreModule} from "../../core/core.module";
import {DynamicModule} from "../../core/shared/interface/dynamic-module.interface";
import {ModuleRegistryService} from "../../core/shared/interface/module-registration.service";
import {DM_TEST_PROVIDERS} from "./test/dm-test-definition";
import {DM_WF_ACTIVITY_PROVIDER} from "./dm-wf-activity.provider";
import {
    DmUploadConsultantComponent
} from "./component/protected-components/consultant-component/upload/dm-upload-consultant.component";
import {
    DmDocumentConsultantComponent
} from "./component/protected-components/consultant-component/dm-document/dm-document-consultant.component";
import {
    ObjectDocumentConsultantComponent
} from "./component/protected-components/consultant-component/object-documents/object-documents-consultant.component";
import {
    MvsCreateObjectTicketComponent
} from "../tm/component/protected-components/create-object-ticket/mvs-create-object-ticket.component";
import {
    DmDocumentTypeObjectComponent
} from "./component/object-components/dm-document-type-object-component/dm-document-type-object.component";
import {DmFormRecognizerTypeObjectComponent} from './component/object-components/dm-form-recognizer-type-object-component/dm-form-recognizer-type-object.component';
// TM-1000001824: Ensure the document-access object component is declared so its template
// (now using <mvs-widget> + PrimeNG p-button/p-message/p-progressSpinner) compiles in a
// module that imports the required UI modules.
import {
    DmDocumentAccessObjectComponent
} from "./component/object-components/dm-document-access-object-component/dm-document-access-object.component";
import {JbModule} from "../../feature-tech/jb/jb.module";
import {
    DmDocumentToolingComponent
} from "./component/protected-components/dm-document-tooling/dm-document-tooling.component";
// CmModule import removed to break circular dependency - dm only uses cm.* as entity type strings
// import {
//     DmDocumentProcessingNewComponent
// } from "./component/dm-document-processing-new/dm-document-processing-new.component";


@NgModule({
  declarations: [
    DmConfigPage,
    DmDashboardComponent,
    DmUploadComponent,
    DmDocumentComponent,
    DmFormRecognizerDataComponent,
    DmDashboardOverviewPage,
    FormRecognizerCanvasDirective,
    DmDocumentPage,
    ObjectDocumentComponent,
    DialogBoxObjectDocumentComponent,
    DmDocumentPdfViewerComponent,
    DmDocumentUploadWfProcessStepActivityComponent,
    DmDashboardActionsPage,
    DmDocumentProcessingComponent,
    DmDocumentUploadComponent,
    DocumentProcessActionsComponent,
    DmOverviewPage,
    DmKpiComponent,
    DmStatisticsComponent,
    DmDocumentFullComponent,
    DmDocumentSideComponent,
    DmDocumentBaseComponent,

  //     Tooling
      DmDocumentToolingComponent,

  //     Object Components
      DmDocumentTypeObjectComponent,
      DmFormRecognizerTypeObjectComponent,
      // TM-1000001824: document-access object component (Azure SAS token table widget)
      DmDocumentAccessObjectComponent,

  //     Consultant
      DmUploadConsultantComponent,
      DmDocumentConsultantComponent,
      ObjectDocumentConsultantComponent,

  //     New
  //     DmDocumentProcessingNewComponent
  ],
  exports:[
    DmConfigPage,
    DmDashboardComponent,
    DmUploadComponent,
    DmDocumentComponent,
    DmFormRecognizerDataComponent,
    DmDashboardOverviewPage,
    FormRecognizerCanvasDirective,
    DmDocumentPage,
    ObjectDocumentComponent,
    DialogBoxObjectDocumentComponent,
    DmDocumentPdfViewerComponent,
    DmDocumentUploadWfProcessStepActivityComponent,
    DmDashboardActionsPage,
    DmDocumentProcessingComponent,
    DocumentProcessActionsComponent,
    DmDocumentFullComponent,
    DmDocumentSideComponent,
    DmDocumentBaseComponent,

  //     Tooling
      DmDocumentToolingComponent,

  //     Object Components
      DmDocumentTypeObjectComponent,
      DmFormRecognizerTypeObjectComponent,
      // TM-1000001824: document-access object component (Azure SAS token table widget)
      DmDocumentAccessObjectComponent,

  //     Consultant
      DmUploadConsultantComponent,
      DmDocumentConsultantComponent,
      ObjectDocumentConsultantComponent,

  //     New
  //     DmDocumentProcessingNewComponent
  ],
    imports: [
        CoreModule,
        WfModule,
        ProgressSpinnerModule,
        ContextMenuModule,
        TabsModule,
        MvsCreateObjectTicketComponent,
        JbModule,
    ],
  providers: [DM_ENTITY_PROVIDER, DM_TEST_PROVIDERS, ...DM_WF_ACTIVITY_PROVIDER]
})
export class DmModule implements DynamicModule {

  alias = 'dm';

  constructor(private moduleRegistry: ModuleRegistryService) {
    this.moduleRegistry.registerModule(this);
  }

  getKpiComponent() {
    return DmKpiComponent;
  }

  getStatisticsComponent() {
    return DmStatisticsComponent;
  }
}

